import React, { useEffect, useRef, useState } from "react";
import { useSearch } from "./SearchContext";
import { GoogleMap, Marker, LoadScript, GoogleMapProps, MarkerProps, MarkerClusterer,InfoWindow   } from "@react-google-maps/api";
import { IListing } from "../../lib";

export interface IMarkerProps {
  listingProps: IListing;
  markerProps?: Partial<MarkerProps>;
  mapClick?: (arg: any) => void;
  clusterer?: any ;
}

const divStyle = {
  background: `white`,
}

export const InfoMarker: React.FC<IMarkerProps> = ({
  listingProps,
  markerProps,
  mapClick,
  clusterer
}) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const compactPrice = `$${new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(listingProps.price!)}`
  
  return (
    (
    <Marker
      noClustererRedraw={true}
      position={listingProps.location!}
      title={listingProps.address?.text}
      key={listingProps.location!.lat + listingProps.location!.lng}
      onClick={(event) => mapClick && mapClick(listingProps)}
      onMouseOver={(event) => setHovered(true)}
      onMouseOut={(event) => setHovered(false)}
      clusterer={clusterer}
      label={{
        text: compactPrice,
        color: "white",
        fontSize: "12px",
        fontWeight: "500"
      }}
      icon={{
        url:hovered?"https://cdn.aglty.io/anne-erwin-sir/commons/listing-marker-normal.svg":"https://cdn.aglty.io/anne-erwin-sir/commons/listing-marker-hover.svg",
      }}
      {...markerProps}
    >
      {hovered && (
        <InfoWindow
          options = {{
            disableAutoPan:true
          }}
        >
          <div style={divStyle}>
              <img
                src={listingProps.defaultImage?.url}
                width={120}
              />
              <strong>{compactPrice}</strong>
              <div>{listingProps.beds ? listingProps.beds : '--'} beds, {listingProps.baths ? listingProps.baths : '--'} baths</div>
              <div>{listingProps.sqft ? listingProps.sqft : '--'} sqft</div>
          </div>
        </InfoWindow>
      )}
    </Marker>
  ));
};
